module.exports = __webpack_public_path__ + "img/rongYu6.d606830d.png";